module.exports = __webpack_public_path__ + "img/Fashion_Recall_3_Set.3635c5fb.png";